import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { FullImageSection } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'

interface Content {
    title?: string
    subtitle?: string
    image?: string
}

interface S1_L3_1Props {
    content?: Content
    blockName?:string
}

const Index = (props: S1_L3_1Props) => {
    const { content = {} } = props
    const { title, subtitle, image } = content
    const heroImage = getImageData(image)
    return (
        <FullImageSection
            aria-label='S1_L3_1'
            image={heroImage.src}
            
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    position: 'absolute',
                    top: '25vh',
                    left: '5vw',
                    gap: 3,
                    width: {
                        xs: '90vw',
                        md: '60vw',
                        lg: '40vw',
                    },
                }}
            >
                <Typography
                    variant='h1'
                    color='white'
                >
                    {title}
                </Typography>
                <Typography
                    variant='body2'
                    color='white'
                >
                    {subtitle}
                </Typography>
            </Box>
        </FullImageSection>
    )
}

export default Index
